// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AssignElevationListQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
}>;


export type AssignElevationListQuery = { __typename?: 'Query', development: { __typename?: 'Development', id: string, options: Array<{ __typename?: 'DevelopmentOption', id: string, shortName?: string | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string, name: string } }> } };

export type AssignElevationListDetailFragment = { __typename?: 'Development', id: string, options: Array<{ __typename?: 'DevelopmentOption', id: string, shortName?: string | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string, name: string } }> };

export type SaveElevationAssignmentMutationVariables = Types.Exact<{
  input: Types.SaveDevelopmentOptionsInput;
}>;


export type SaveElevationAssignmentMutation = { __typename?: 'Mutation', saveDevelopmentOptions: { __typename?: 'SaveDevelopmentOptionsResult', developmentOptions: Array<{ __typename?: 'DevelopmentOption', id: string, shortName?: string | null | undefined }> } };

export const AssignElevationListDetailFragmentDoc = gql`
    fragment AssignElevationListDetail on Development {
  id
  options {
    id
    shortName
    globalOption {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;
export const AssignElevationListDocument = gql`
    query AssignElevationList($developmentId: ID!) {
  development(id: $developmentId) {
    ...AssignElevationListDetail
  }
}
    ${AssignElevationListDetailFragmentDoc}`;

/**
 * __useAssignElevationListQuery__
 *
 * To run a query within a React component, call `useAssignElevationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignElevationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignElevationListQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *   },
 * });
 */
export function useAssignElevationListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssignElevationListQuery, AssignElevationListQueryVariables> & ({ variables: AssignElevationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssignElevationListQuery, AssignElevationListQueryVariables>(AssignElevationListDocument, options);
      }
export function useAssignElevationListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssignElevationListQuery, AssignElevationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssignElevationListQuery, AssignElevationListQueryVariables>(AssignElevationListDocument, options);
        }
// @ts-ignore
export function useAssignElevationListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssignElevationListQuery, AssignElevationListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssignElevationListQuery, AssignElevationListQueryVariables>;
export function useAssignElevationListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssignElevationListQuery, AssignElevationListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssignElevationListQuery | undefined, AssignElevationListQueryVariables>;
export function useAssignElevationListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssignElevationListQuery, AssignElevationListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AssignElevationListQuery, AssignElevationListQueryVariables>(AssignElevationListDocument, options);
        }
export type AssignElevationListQueryHookResult = ReturnType<typeof useAssignElevationListQuery>;
export type AssignElevationListLazyQueryHookResult = ReturnType<typeof useAssignElevationListLazyQuery>;
export type AssignElevationListSuspenseQueryHookResult = ReturnType<typeof useAssignElevationListSuspenseQuery>;
export type AssignElevationListQueryResult = Apollo.QueryResult<AssignElevationListQuery, AssignElevationListQueryVariables>;
export const SaveElevationAssignmentDocument = gql`
    mutation SaveElevationAssignment($input: SaveDevelopmentOptionsInput!) {
  saveDevelopmentOptions(input: $input) {
    developmentOptions {
      id
      shortName
    }
  }
}
    `;
export type SaveElevationAssignmentMutationFn = Apollo.MutationFunction<SaveElevationAssignmentMutation, SaveElevationAssignmentMutationVariables>;

/**
 * __useSaveElevationAssignmentMutation__
 *
 * To run a mutation, you first call `useSaveElevationAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveElevationAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveElevationAssignmentMutation, { data, loading, error }] = useSaveElevationAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveElevationAssignmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveElevationAssignmentMutation, SaveElevationAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveElevationAssignmentMutation, SaveElevationAssignmentMutationVariables>(SaveElevationAssignmentDocument, options);
      }
export type SaveElevationAssignmentMutationHookResult = ReturnType<typeof useSaveElevationAssignmentMutation>;
export type SaveElevationAssignmentMutationResult = Apollo.MutationResult<SaveElevationAssignmentMutation>;
export type SaveElevationAssignmentMutationOptions = Apollo.BaseMutationOptions<SaveElevationAssignmentMutation, SaveElevationAssignmentMutationVariables>;